// MongoDB stores datetimes as UTC but Motor returns them without a timezone,
// so the API serializes timestamps like created_at as an offset-less string
// ("2026-03-26T13:32:28.923"). new Date() and date-fns parseISO both read an
// offset-less datetime as LOCAL time, so a document saved at 13:32 UTC shows
// hours off for anyone not on UTC - a user at UTC+5 sees a fresh upload as
// "5h ago".
//
// Stamp offset-less *datetime* strings as UTC before parsing. Date-only
// strings (a calendar date such as a task due date) are left untouched -
// forcing them to UTC would shift the day for some timezones.
export function asUtcIfNaive(value) {
  if (typeof value !== 'string') return value;
  const s = value.trim();
  const hasTime = /\d{2}:\d{2}/.test(s);
  const hasTimezone = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(s);
  if (hasTime && !hasTimezone) return `${s.replace(' ', 'T')}Z`;
  return value;
}
